import { FormEvent } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { Route } from '../../../enums';

import { StoreState, useLoginMemberEffect } from '../../../services';
import {
  MemberLoginFormFields,
  useMemberLoginFormEffect,
} from '../../../forms';

export const useDoctorLoginBoxEffect = () => {
  const router = useRouter();

  const member = useSelector(
    (state: StoreState) => state.partner.member.member
  );

  const { isValid, getFieldValues, members } = useMemberLoginFormEffect();

  const { loginMember, loading, success, error } = useLoginMemberEffect(() => {
    console.log('Redirect from here');
    router.push(Route.PATIENT_DOCTOR);
  });

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = getFieldValues() as MemberLoginFormFields;

    loginMember(form.username || '', form.password || '');
  };

  return { member, isValid, members, onSubmit, loading, success, error };
};
